<template>
  <div class="field-wrapper">
    <label>{{ t('automatedScenarios.actions.sending_channel.template_config.reuse_a_previous_coupon.label') }}</label>
    <Dropdown
      :model-value="modelValue"
      :options="options"
      option-label="label"
      option-value="value"
      class="w-full"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Dropdown from 'primevue/dropdown';

export default defineComponent({
  name: 'ReuseCouponSelector',

  components: {
    Dropdown,
  },

  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    options: {
      type: Array as PropType<Array<{ label: string; value: number }>>,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
